import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Confirm from "../../Components/confirm";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../../Components/ToastManager";
import ToggleSwitch from "../../Components/ToggleSwitch";
import { Modal } from "react-bootstrap";
import DraggableComponent from "../../Components/DraggableComponent";
import NoDocument from "./NoDocument";
import SelectField from "../../Components/SelectField";
import InputField from "../../Components/InputField";
import * as Yup from 'yup';



const Signature = ({ unSavedChanges }: any) => {
  const [documents, setDocuments] = useState<any>([]);
  const [signatures, setSignatures] = useState<any>([]);
  const [getAllSignatures, setGetAllSignatures] = useState<any>([]);
  const [unSaved, setUnSaved] = useState<boolean>(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [hover, setHover] = useState<number | null>(null);
  const signatureRef = useRef<HTMLInputElement>(null);
  const sassOrgId = CommonUtil.getSaasOrgId();
  const entityRef = useRef<HTMLInputElement>(null);
  const [showPopup, setShowPopup] = useState<boolean>(false);

  useEffect(() => {
    getSignatures();
    getAllDocumentTypes();
  }, []);

  useEffect(() => {
    const isDifferent =
      JSON.stringify(signatures) !== JSON.stringify(getAllSignatures);
    setUnSaved(isDifferent);
    unSavedChanges(isDifferent);
  }, [signatures, getAllSignatures]);

  useEffect(() => {
    if(signatures){
      console.log("Signature",signatures)
    }
  }, [signatures]);

  const onLoginError = (err: any) => {
    console.log(err);
  };

  const getAllDocumentTypes = ()=>{
    const orgUrl=`api/v2/config/document-types/all/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetAllDocTypes,onLoginError)
  };



  
  const onGetAllDocTypes = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        setDocuments(restData);
      } else {
        setDocuments([]);
      }
    }
  };
  const getSignatures = () => {
    const orgUrl = "api/v2/config/signatures/all/?orgId=" + CommonUtil.getSaasOrgId();
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onGetAllSuccess, onLoginError);
  };

  const onGetAllSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        setGetAllSignatures(restData);
        setSignatures((prevSignatures: any) => [...restData]);
      } else {
        setSignatures([]);
      }
    }
  };

  const handleEdit = (index: number, sig: any) => {
    setEditIndex(index);
  
    editFormik.setValues({
      signatureBy: sig.signatureBy,
      isUserNameRequired: sig.isUserNameRequired,
      entityName: sig.entityName,
      docTypeId: sig.docTypeId,
      isStart: sig.isStart,
      isEnd: sig.isEnd,
    });
  };

  const validationSchema = Yup.object().shape({
    signatureBy: Yup.string().required("Signature By is required"),
    entityName: Yup.string().when("signatureBy", (signatureBy, schema) => 
      signatureBy?.[0] === "Others" ? schema.required("Entity Name is required"): schema.notRequired()
    ),
    docTypeId: Yup.string().required("Document Type is required"),
    isStart: Yup.boolean(),
    isEnd: Yup.boolean(),
  }).test(
    "signature-position",
    "Select at least one: Signature at Start or End",
    function (value) {
      return value?.isStart === true || value?.isEnd === true;
    }
  );

  
  const addFormik = useFormik({
    initialValues: {
      signatureBy: "",
      entityName: "",
      isUserNameRequired: false,
      docTypeId: null,
      isStart: false,
      isEnd: false,
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values);
    },
  });

  const editFormik = useFormik({
    initialValues: {
      signatureBy: "",
      entityName: "",
      isUserNameRequired: false,
      docTypeId: null,
      isStart: false,
      isEnd: false,
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values);
      // resetForm();
    },
  });
  
  const onSubmitForm = (values: any) => {
    const hasValidSignature =  values.isStart || values.isEnd
  
    if (!hasValidSignature) {
      ToastManager.showToast("Please select at least one: Signature at Start or Signature at End.", "Error");
      return;
    }else{
    const isEdit = editIndex !== null;
    setSignatures((prevSignatures: any) => {
      if (isEdit) {
        return prevSignatures.map((sig: any, index: number) =>
          index === editIndex
            ? {
                ...sig,
                signatureBy: values.signatureBy || sig.signatureBy,
                entityName: values.entityName || sig.entityName,
                isUserNameRequired: values.isUserNameRequired ?? sig.isUserNameRequired,
                docTypeId: values.docTypeId ?? sig?.docTypeId,
                isStart: values.isStart ?? sig?.isStart,
                isEnd: values.isEnd ?? sig?.isEnd,
              }
            : sig
        );
      } else {
        const newSequenceId =
          prevSignatures.length > 0
            ? Math.max(...prevSignatures.map((s: any) => s.sequenceId || 0)) + 1
            : 1;
  
        return [
          ...prevSignatures,
          {
            signatureBy: values.signatureBy,
            signatureId: null,
            entityName: values.entityName,
            isUserNameRequired: values.isUserNameRequired,
            docTypeId: values.docTypeId,
            isStart: values.isStart,
            isEnd: values.isEnd,
            sequenceId: newSequenceId,
            saasOrgId: sassOrgId,
            inspectionOrgId: sassOrgId,
          },
        ];
      }
    });
  
    if (isEdit) {
      setEditIndex(null);
      editFormik.resetForm();
    }else{
      addFormik.resetForm();
      setShowPopup(false);
    }
  }
  };
  
  const handleBulkSubmit = () => {
    console.log("Saved", signatures)
    const url = `api/v2/config/signatures/bulk?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, signatures, "", "POST", true, onSubmitSuccess, onLoginError);
  };

  const onSubmitSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData.errorMessage) {
        ToastManager.showToast("Signature Saved Successfully", "Success");
        setSignatures([]);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getSignatures();
    }
  };

  const handleDelete = (sigId: any, index: number) => {
    Confirm.show("Confirm", "Would you like to delete this Signature?", [
      {
        label: "Yes",
        callback: function () {
          if (sigId) {
            setSignatures((prevSignatures: any) =>
              prevSignatures.filter((_: any, i: number) => i !== index)
            );
            let sigDelAPI = `api/v2/config/signatures/${sigId}?orgId=${sassOrgId}`;
            NetworkManager.sendJsonRequest(sigDelAPI, "", "", "DELETE", true, onDeleteSuccess, onLoginError);
          } else {
            setSignatures((prevSignatures: any) =>
              prevSignatures.filter((_: any, i: number) => i !== index)
            );
            ToastManager.showToast("Signature Removed", "Info");
          }
        },
      },
      { label: "No" },
    ]);
  };

  const onDeleteSuccess = (dataObj: any) => {
    if (dataObj) {
      var restData = CommonUtil.parseData(dataObj);
      if (!restData.errorMessage) {
        ToastManager.showToast("Signature Deleted Successfully", "Info");
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  };

  return (
    <div>
      <NoDocument>
      <div className={`d-flex align-items-center justify-content-between`}>
        <div className={`col-lg-6 rounded bg-light`}>
          <div className={`d-flex p-3 ${signatures.length > 0 ? "d-none" : ""}`}>
            <span>
              <i className="fa fa-info-circle me-3 icon-muted"></i>
            </span>
            <div className="fw-400 text-muted">
              <span className="fw-600 text-dark">No Signature added yet</span>
              <br></br>
            </div>
          </div>
        </div>
        <div className="col-lg-6 text-end">
          <button type="submit" className="btn btn-success" 
            onClick={()=>{
              addFormik.resetForm();
              setShowPopup(true);
            }}>
            <div className="d-flex justify-content-center align-item-center">Add New Signature</div>
          </button>
          <button type="submit" className="btn btn-dark ms-1" onClick={handleBulkSubmit} disabled={!unSaved}>
            <div className="d-flex justify-content-center align-item-center">Save</div>
          </button>
        </div>
        </div>
        </NoDocument>

      <div style={{overflowY: "auto", width:"100%", overflowX: "hidden", height:`${window.innerHeight - 220}px`, paddingRight:"12px"}}>
      <div className="col-lg-12 mb-2">
        {signatures.length > 0 && (
          <form onSubmit={editFormik.handleSubmit} >
            {signatures.map((sig: any, index: any) => (
              <div
                // title={unSaved || editIndex !== null ? "" : "Drag & Drop"}
                draggable={unSaved || editIndex !== null ? false : true}
                // onDragStart={(event) => handleDragStart(event, doc)}
                // onDragOver={handleDragOver}
                // onDrop={(event) => handleDrop(event, doc)}
                key={index}
                className={`${ unSaved || editIndex !== null ? "" : ""} create-card m-1 mb-3 px-4 pt-4 pb-2 position-relative`}
                style={{
                  marginLeft: unSaved || editIndex !== null ? "0px" : "",
                }}
                onMouseOver={() => setHover(index)}
                onMouseOut={() => setHover(null)}
              >
              <div className="row">
                <div className="col-md-4 mb-4">
                  <SelectField placeholder="Signature By" name={`signatureBy`} className="form-select"
                    value={editIndex === index ? editFormik.values.signatureBy : sig.signatureBy}
                    onChange={editFormik.handleChange}
                    disabled={editIndex !== index}
                  >
                    <option value="" disabled>Select</option>
                    <option value="Driver">Driver</option>
                    <option value="Inspector">Inspector</option>
                    <option value="Others">Others</option>
                  </SelectField>
                  {editFormik.touched.signatureBy && editFormik.errors.signatureBy && (
                    <small className="ms-2 text-danger fw-700">{editFormik.errors.signatureBy}</small>
                  )}
                </div>
                {(editIndex === index ? editFormik.values.signatureBy === "Others" : sig.signatureBy === "Others") && (
                <div className="col-md-4 mb-4">
                  <InputField type="text" name="entityName" className="form-control" placeholder="Entity Name"
                    value={editIndex === index ? editFormik.values.entityName : sig.entityName}
                    onChange={editFormik.handleChange}
                    disabled={editIndex !== index}
                  />
                  {editFormik.touched.entityName && editFormik.errors.entityName && (
                    <small className="ms-2 text-danger fw-700">{editFormik.errors.entityName}</small>
                  )}
                </div>)}
                <div className="col-md-4 mb-4 d-flex align-items-center">
                  <div className="d-flex align-items-center py-2">
                    <label className="toggle mb-0">
                      <input className="toggle-checkbox" type="checkbox" name={`isUserNameRequired`}
                        checked={editIndex === index ? editFormik.values.isUserNameRequired : sig.isUserNameRequired}
                        onChange={editFormik.handleChange}
                        disabled={editIndex !== index} />
                      <div className="toggle-switch"></div>
                    </label>
                    <label className="form-check-label fw-400"></label>
                    <div className="ms-1">Capture User Name</div>
                  </div>
                </div>
              </div>
              <div className="" id="signatureDocument">
                <div className="row mb-2">
                  <div className="col-md-4">
                    <SelectField placeholder="Signature for Document" name={`docTypeId`} className="form-select" id="exampleFormControlSelect2"
                      value={editIndex === index ? editFormik.values.docTypeId : sig.docTypeId}
                      onChange={editFormik.handleChange}
                      disabled={editIndex !== index}
                    >
                      <option value="" disabled>Select Document Type</option>
                      {documents.map((option: any) => (
                      <option key={option.documentTypesId} value={option.documentTypesId} data-name={option.documentTypesName}>
                        {option.documentTypesName}
                      </option>
                      ))}
                    </SelectField>
                    {editFormik.touched.docTypeId && editFormik.errors.docTypeId && (
                      <small className="ms-2 text-danger fw-700">{editFormik.errors.docTypeId}</small>
                    )}
                  </div>
                  <div className="col-md-8 ">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center me-3">
                        <label className="toggle mb-0">
                          <input className="toggle-checkbox" type="checkbox" name={`isStart`}
                            checked={editIndex === index ? editFormik.values?.isStart : sig.isStart}
                            onChange={editFormik.handleChange}
                            disabled={editIndex !== index} />
                          <div className="toggle-switch"></div>
                        </label>
                        <label className="form-check-label fw-400"></label>
                        <div className="ms-1">Signature at Start</div>
                      </div>
                      <div className="d-flex align-items-center py-2">
                        <label className="toggle mb-0">
                          <input className="toggle-checkbox" type="checkbox" name={`isEnd`}
                            checked={editIndex === index ? editFormik.values?.isEnd : sig.isEnd}
                            onChange={editFormik.handleChange}
                            disabled={editIndex !== index} />
                          <div className="toggle-switch"></div>
                        </label>
                        <label className="form-check-label fw-400"></label>
                        <div className="ms-1">Signature at End</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {editIndex === index && <div className="row mt-2">
                <small className="fst-italic"><span className="text-danger">Note:</span> Please select at least one: Signature at Start or Signature at End.</small>
              </div>}
              <div className="row mt-1">
                <div className="col-md-12 d-flex justify-content-end">
                    {editIndex !== index ? (
                      <div className="d-flex justify-content-end">
                      <button type="button" title="Edit" className="btn btn-icon"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEdit(index, sig)}} >
                        <img src={"./../images/edit.svg"} alt="edit" width={18} height={18} />
                      </button>
                        <button type="button" title="Close" className="btn btn-icon"
                          onClick={() => handleDelete(sig.signatureId, index)}>
                          <img src={"./../images/delete.svg"} alt="delete" width={18} height={18} />
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-end">
                        <button type="submit" className="btn btn-icon" title="Save">
                          <img src={"./../images/check.svg"} alt="check" width={18} height={18} />
                        </button>
                        <button type="button" className="btn btn-outline-icon" title="Cancel" onClick={() => setEditIndex(null)}>
                          <img src={"./../images/cancel.svg"} alt="cancel" width={18} height={18} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
            </div>))}
          </form>
        )}
        <Modal show={showPopup} centered dialogAs={DraggableComponent} id="devEstPopup" size={`lg`}>
          <div className="modal-content new-interchange" id="devEstContentPopup" 
            
          ><Modal.Header className="modal-header" closeButton={false}>
              <h5 className="modal-title mt-0">Add New Signature</h5>
              <button type="button" className="isModal" data-dismiss="modal" aria-label="Close"
                style={{ marginLeft: "0px", background: "none" }}
                onClick={()=>{
                  addFormik.resetForm();
                  setShowPopup(false);
                }} >
                  <span aria-hidden="true">&times;</span>
              </button>
            </Modal.Header>
            <form onSubmit={addFormik.handleSubmit} className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <SelectField placeholder="Signature By" name="signatureBy" className="form-select" 
                    value={addFormik.values.signatureBy}
                    onChange={addFormik.handleChange}
                  >
                    <option value="" disabled>Select</option>
                    <option value="Driver">Driver</option>
                    <option value="Inspector">Inspector</option>
                    <option value="Others">Others</option>
                  </SelectField>
                  {addFormik.touched.signatureBy && addFormik.errors.signatureBy && (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.signatureBy}</small>
                    )}
                </div>
                {addFormik.values.signatureBy === "Others" && (
                <div className="col-md-6 mb-4 ">
                  <InputField type="text" name="entityName" autoFocus className="form-control" ref={entityRef} 
                    placeholder="Entity Name"
                    value={addFormik.values.entityName}
                    onChange={addFormik.handleChange}
                  />
                  {addFormik.touched.entityName && addFormik.errors.entityName && (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.entityName}</small>
                    )}
                </div>)}
                <div className="col-md-12 mb-4 d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <label className="toggle mb-0">
                      <input className="toggle-checkbox" type="checkbox" name="isUserNameRequired" 
                        checked={addFormik.values.isUserNameRequired}
                        onChange={addFormik.handleChange} />
                      <div className="toggle-switch"></div>
                    </label>
                    <label className="form-check-label fw-400"></label>
                    <div className="ms-2">Capture User Name</div>
                  </div>
                </div>
              </div>
              <div className="mb-4 mt-2" id="signatureDocument">
                <div className="row">
                  <div className="col-md-4 mb-4">
                    <SelectField name={`docTypeId`} className="form-select" placeholder="Signature for document"
                      value={addFormik.values.docTypeId || ""}
                      onChange={addFormik.handleChange}
                  >
                    <option value="" disabled>Select Document Type</option>
                    {documents.map((option: any) => (
                      <option key={option.documentTypesId} value={option.documentTypesId} data-name={option.documentTypesName}>
                        {option.documentTypesName}
                      </option>
                    ))}
                  </SelectField>
                  {addFormik.touched.docTypeId && addFormik.errors.docTypeId && (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.docTypeId}</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-4 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <label className="toggle mb-0">
                        <input className="toggle-checkbox" type="checkbox" name={`isStart`} 
                          checked={addFormik.values.isStart}
                          onChange={addFormik.handleChange} />
                        <div className="toggle-switch"></div>
                      </label>
                      <label className="form-check-label fw-400"></label>
                      <div className="ms-2">Signature at Start</div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <label className="toggle mb-0">
                        <input className="toggle-checkbox" type="checkbox" name={`isEnd`}
                          checked={addFormik.values.isEnd}
                          onChange={addFormik.handleChange}/>
                        <div className="toggle-switch"></div>
                      </label>
                      <label className="form-check-label fw-400"></label>
                      <div className="ms-2">Signature at End</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <small className="fst-italic"><span className="text-danger">Note:</span> Please select at least one: Signature at Start or Signature at End.</small>
              </div>
              <div className="row mt-2 px-1">
                <div className="col-md-12 d-flex justify-content-end">
                  <button type="submit" className="btn btn-dark me-2 d-flex align-items-center">
                    <i className="fa-solid fa-plus me-2"></i> Add</button>
                  <button type="button" className="btn btn-outline-light ms-1"
                    onClick={()=>{
                      addFormik.resetForm();
                      setShowPopup(false);
                    }} >Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </Modal>
        </div>
        </div>
    </div>
  );
};

export default Signature;
